import styled from "styled-components";

const Container = styled.div`
  height: 30px;
  background-color: darkred;
  color: #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  //  font-style: italic;
`;

function printDate() {
  var today = new Date();
  var dd = String(today.getDate());
  var mm = today.toLocaleString('default', { month: 'long' });
  var yyyy = today.getFullYear();
  var today = dd + ' ' + mm + ' ' + yyyy;
  return today;
}

const Footer = () => {
  return (
    <div>
      <Container>Last updated: 26 September 2025.</Container>
    </div>
  );
};

export default Footer;
